import axios from '@/utils/request.js'

// 获取验证码
export function getcode(params) {
  return axios.post('/user/finance_getcode', {
    params
  })
}
// 用户登录
export function userlogin(params) {
  return axios.post('/user/userlogin', {
    params
  })
}
export function pwuserlogin(params) {
  return axios.post('/user/pwuserlogin', {
    params
  })
}
// 获取首页数据
export function useradd(params) {
  return axios.post('/user/add', {
    params
  })
}
//user列表
export function userlist(params) {
	console.log(params);
  return axios.get('/user/userlist', {
    params
  })
}